/* This file was generated automatically. Do not edit manually. */

import { createAccountingExportIntegrationAccountingExportRepository as accountingExportIntegrationAccountingExport } from './accountingExportIntegrationAccountingExport';
import { createAccountingExportIntegrationConfigurationRepository as accountingExportIntegrationConfiguration } from './accountingExportIntegrationConfiguration';
import { createAccountingExportIntegrationExportRepository as accountingExportIntegrationExport } from './accountingExportIntegrationExport';
import { createAccountingExportIntegrationTestRepository as accountingExportIntegrationTest } from './accountingExportIntegrationTest';

export * from './types';

export const accountingExportIntegrationApiBasePath = '/api/accountingExport/v1';

export const accountingExportIntegrationRestRepositoryFactories = {
    accountingExportIntegrationAccountingExport,
    accountingExportIntegrationConfiguration,
    accountingExportIntegrationExport,
    accountingExportIntegrationTest,
};
